export default "__VITE_ASSET__BukM6eZb__"